import React, { useState, useEffect,useRef, useContext} from "react";
import { UserCheck, Search } from "lucide-react";
import "./leadassign.css";
import "../Home/global.css";
import { useQuery, useMutation } from "@apollo/client";
import { Box } from "@mui/material";
import SearchableDropdown from "../reusableField/searchableDropdownField";
import { RoleContext } from "../reusableField/roleContext";
import {
  CURRENT_USER_PROFIILE,
  GET_JOBROLE_LEADS,
  GET_FLS_DETAIILS_NORMAL,
  GET_FLS_DETAIILS,
  CURRENT_USER_ACCOUNT,
  UPDATE_LEAD_ASSIGNMENT,
  GET_ASSIGNED_UNASSIGNED_LEADS,
} from "../services/userApi";

const LeadAssign = () => {
  const { roleId } = useContext(RoleContext);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [selectedFLSForLeads, setSelectedFLSForLeads] = useState({});
  const [activeTab, setActiveTab] = useState("manual"); // New state for tab switching

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [hasPreviousPage, setHasPreviousPage] = useState(false);
  const limit = 20; // or whatever limit you want

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 1500); // 1500ms delay

    return () => clearTimeout(timer);
  }, [searchTerm]);

  const { data: userProfileData, loading: userProfileLoading } = useQuery(
    CURRENT_USER_PROFIILE
  );
  const jobRoleId = userProfileData?.currentUserProfile?.roleId;

  const {
    data: accountData,
    loading: accountLoading,
    error: accountError,
  } = useQuery(CURRENT_USER_ACCOUNT);
  const accountId = accountData?.currentUserAccount?.id;

  const {
    data: assignedFlsData,
    loading: assignedFlsLoading,
    error: assignedFlsError,
    refetch: assignedFlsRefetch,
  } = useQuery(GET_FLS_DETAIILS, {
    variables: {
      searchTerm: "",
      pagingCriteria: {
        limit: limit,
        page:1,
        sortByField: "created_at",
        sortOrder: "desc",
      },
      jobroleId: roleId || jobRoleId,
      // accountId: accountId,
    },
    skip: !roleId || !accountId,
    fetchPolicy: "no-cache",
  });

  const {
    data: assignedLeadsData,
    loading: assignedLeadsLoading,
    error: assignedLeadsError,
    refetch: assignedLeadsRefetch,
  } = useQuery(GET_ASSIGNED_UNASSIGNED_LEADS, {
    variables: {
      searchTerm: debouncedSearchTerm || "",
      pagingCriteria: {
        limit: limit,
        page: currentPage,
        sortByField: "created_at",
        sortOrder: "desc",
      },
      jobroleId: roleId || jobRoleId,
      lifetime: activeTab === "manual" ? false : true,
    },
    skip: !jobRoleId ,
    fetchPolicy: "no-cache",
  });

  const [
    addUpdateLeadAssignment,
    { loading: mutationLoading, error: mutationError },
  ] = useMutation(UPDATE_LEAD_ASSIGNMENT);

  // Add this useEffect after your existing ones
  useEffect(() => {
    if (
      assignedLeadsData?.getAssignedOrUnassignedLeadsForLifetimeOnJobrole
        ?.pageMeta
    ) {
      const {
        totalCount,
        totalPages,
        currentPage: apiCurrentPage,
        hasNextPage,
        hasPreviousPage,
      } = assignedLeadsData.getAssignedOrUnassignedLeadsForLifetimeOnJobrole
        .pageMeta;

      setTotalCount(totalCount);
      setTotalPages(totalPages);
      // setCurrentPage(apiCurrentPage);
      setHasNextPage(hasNextPage);
      setHasPreviousPage(hasPreviousPage);
    }
  }, [assignedLeadsData]);

  // Reset to page 1 when search term changes
  useEffect(() => {
    if (debouncedSearchTerm !== "") {
      setCurrentPage(1);
    }
  }, [debouncedSearchTerm]);

  const getFieldValue = (leadFormDetails, fieldType) => {
    console.log("leadFormDetails:", leadFormDetails);

    if (!leadFormDetails || !leadFormDetails.questions) {
      console.log("No leadFormDetails or questions");
      return "";
    }

    console.log("Questions:", leadFormDetails.questions);

    const question = leadFormDetails.questions.find((q) =>
      q.question?.toUpperCase().includes(fieldType.toUpperCase())
    );

    console.log(`Looking for ${fieldType}, found:`, question);
    console.log("User response:", question?.userResponse);

    if (question?.userResponse?.response) {
      return question.userResponse.response;
    }

    return "";
  };

  const getFieldValueByName = (leadFormDetails, fieldName) => {
    console.log("getFieldValueByName - fieldName:", fieldName);

    if (!leadFormDetails || !leadFormDetails.questions) {
      console.log("No leadFormDetails or questions");
      return "";
    }

    const question = leadFormDetails.questions.find((q) =>
      q.question?.toUpperCase().includes(fieldName.toUpperCase())
    );

    console.log(`Found question for ${fieldName}:`, question);

    if (question?.userResponse?.response) {
      return question.userResponse.response;
    }

    return "";
  };

  const transformLeadsData = (apiData) => {
    console.log("API Data:", apiData);

    if (!apiData?.getAssignedOrUnassignedLeadsForLifetimeOnJobrole?.data) {
      console.log("No data in API response");
      return [];
    }

    const leads = apiData.getAssignedOrUnassignedLeadsForLifetimeOnJobrole.data;
    console.log("Leads data:", leads);

    return leads.map((lead) => {
      console.log("Processing lead:", lead);
      console.log("Lead form details:", lead.leadFormDetails);

      const fullName = getFieldValueByName(lead.leadFormDetails, "Full Name");
      console.log("Extracted fullName:", fullName);

      const email = getFieldValue(lead.leadFormDetails, "Email");
      console.log("Extracted email:", email);

      const contactNumber = getFieldValue(
        lead.leadFormDetails,
        "Contact Number"
      );
      console.log("Extracted contactNumber:", contactNumber);

      return {
        id: lead.id,
        name: fullName || "N/A",
        phone: contactNumber || "N/A",
        email: email || "N/A",
        status: lead?.status?.statusName,
        leadFormDetails: lead?.leadFormDetails,
        assignedUser: lead?.assignedUser,
      };
    });
  };

  const transformFlsData = (apiData) => {
    if (!apiData?.getOnlyUsersForRoleWithSkipTop?.data) return [];

    return apiData.getOnlyUsersForRoleWithSkipTop.data.map((fls) => {
      return {
        id: fls.id,
        name: fls.name,
        phone: fls.phoneNumber,
        email: fls.email,
        city: fls.cityName,
        state: fls.stateName,
        // experience: calculateExperience(fls.roleStartDate),
      };
    });
  };

  const leads = transformLeadsData(assignedLeadsData);
  const fls = transformFlsData(assignedFlsData);

  const getFLSOptionsForLead = (lead) => {
    const assignedUserId = lead.assignedUser?.id;

    return fls.map((flsUser) => ({
      ...flsUser,
      disabled: assignedUserId === flsUser.id,
      displayName:
        assignedUserId === flsUser.id
          ? `${flsUser.name} (Already Assigned)`
          : flsUser.name,
    }));
  };

  const handleFLSSelection = (leadId, flsId) => {
    setSelectedFLSForLeads((prev) => ({
      ...prev,
      [leadId]: flsId,
    }));
  };

  const handleAssign = async (leadId, userId) => {
    const selectedFLS = selectedFLSForLeads[leadId];
    if (selectedFLS) {
      console.log(`Assigning lead ${leadId} to FLS ${selectedFLS}`);

      try {
        const response = await addUpdateLeadAssignment({
          variables: {
            leadId: parseInt(leadId),
            userId: parseInt(userId),
          },
        });

        console.log("API response:", response);

        await assignedLeadsRefetch();
        setSelectedFLSForLeads((prev) => {
          const updated = { ...prev };
          delete updated[leadId];
          return updated;
        });
      } catch (error) {
        console.error("Error assigning lead:", error);
      }
    }
  };

  const isLeadAssigned = (lead) => {
    return lead.assignedUser && lead.assignedUser.id;
  };

  const getAssignedUserName = (lead) => {
    return lead.assignedUser?.name || "";
  };

  const filteredLeads = leads.filter(
    (lead) => lead.name.toLowerCase()
    // .includes(searchTerm.toLowerCase())
    //   lead.id.includes(searchTerm.toLowerCase())
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleNextPage = () => {
    if (hasNextPage) {
      handlePageChange(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (hasPreviousPage) {
      handlePageChange(currentPage - 1);
    }
  };

  const PaginationBar = ({
    currentPage,
    totalPages,
    totalCount,
    limit,
    hasPreviousPage,
    hasNextPage,
    handlePreviousPage,
    handleNextPage,
    handlePageChange,
  }) => (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        // mt: 2,
        py: 2,
        px: 2,
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {/* Left: Total Count */}
      <div className="text-sm text-gray-600">
        Showing {(currentPage - 1) * limit + 1} to{" "}
        {Math.min(currentPage * limit, totalCount)} of {totalCount} leads
      </div>

      {/* Center: Page Numbers */}
      <div className="flex items-center gap-2">
        <button
          onClick={handlePreviousPage}
          disabled={!hasPreviousPage}
          className={`px-4 py-2 rounded-md border font-medium transition-colors ${
            hasPreviousPage
              ? "bg-white border-[#dc3545] text-[#dc3545] hover:bg-[#dc3545] hover:text-white"
              : "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
          }`}
        >
          Prev
        </button>

        {/* Page Numbers */}
        <div className="flex items-center gap-1">
          {(() => {
            const pages = [];
            const maxVisible = 5;
            let startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisible / 2)
            );
            let endPage = Math.min(totalPages, startPage + maxVisible - 1);

            if (endPage - startPage < maxVisible - 1) {
              startPage = Math.max(1, endPage - maxVisible + 1);
            }

            if (startPage > 1) {
              pages.push(
                <button key={1} onClick={() => handlePageChange(1)}>
                  1
                </button>
              );
              if (startPage > 2) {
                pages.push(<span key="ellipsis1">...</span>);
              }
            }

            for (let i = startPage; i <= endPage; i++) {
              pages.push(
                <button
                  key={i}
                  onClick={() => handlePageChange(i)}
                  className={`px-3 py-2 rounded-md border font-medium transition-colors ${
                    currentPage === i
                      ? "bg-[#dc3545] text-white border-[#dc3545]"
                      : "border-gray-300 hover:border-[#dc3545] hover:bg-gray-50"
                  }`}
                >
                  {i}
                </button>
              );
            }

            if (endPage < totalPages) {
              if (endPage < totalPages - 1) {
                pages.push(<span key="ellipsis2">...</span>);
              }
              pages.push(
                <button
                  key={totalPages}
                  onClick={() => handlePageChange(totalPages)}
                >
                  {totalPages}
                </button>
              );
            }

            return pages;
          })()}
        </div>

        <button
          onClick={handleNextPage}
          disabled={!hasNextPage}
          className={`px-4 py-2 rounded-md border font-medium transition-colors ${
            hasNextPage
              ? "bg-white border-[#dc3545] text-[#dc3545] hover:bg-[#dc3545] hover:text-white"
              : "bg-gray-100 border-gray-300 text-gray-400 cursor-not-allowed"
          }`}
        >
          Next
        </button>
      </div>

      {/* Right: Page Info */}
      <div className="text-sm text-gray-600">
        Page {currentPage} of {totalPages}
      </div>
    </Box>
  );

  // Tab content renderer
  const renderManualTabContent = () => {
    return (
      <>
        <div className="relative flex-1 max-w-md my-[10px] mb-6">
          <input
            type="text"
            placeholder="Search leads by name.."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2 border border-[#888888] rounded-[4px] focus:outline-none focus:border-[#dc3545] text-[14px]"
          />
          <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        </div>

        <div className="">
          <div className="grid grid-cols-3">
            <div className="px-5 py-4 text-left text-sm font-semibold text-gray-700 ">
              Leads
            </div>
            <div className="px-6 py-4 text-center text-sm font-semibold text-gray-700 ">
              Select User
            </div>
            <div className="px-6 py-4 text-center text-sm font-semibold text-gray-700 ">
              Action
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="border border-[#888888] rounded-[4px] ">
          <table className="w-full">
            <tbody className="bg-white h-1/4">
              {filteredLeads.map((lead, index) => (
                <tr
                  key={lead.id}
                  className={`${
                    index !== filteredLeads.length - 1
                      ? "border-b border-gray-200"
                      : ""
                  } hover:bg-gray-50 transition-colors overflow-visible-important
                  }`}
                >
                  <td className="w-1/3 px-4 py-2 ">
                    <div className="flex items-center gap-2">
                      <span className="font-medium text-gray-900 text-sm">
                        #{lead.id}
                      </span>
                      <span className="text-gray-700 text-sm">{lead.name}</span>
                    </div>
                  </td>

                  {/* FLS Selection Column */}
                  <td className="w-1/3 px-6 py-2  w-1/3 h-1/2 overflow-visible-important">
                    <SearchableDropdown
                      options={getFLSOptionsForLead(lead)}
                      label="displayName"
                      id="id"
                      selectedVal={selectedFLSForLeads[lead.id] || ""}
                      handleChange={(flsId) =>
                        handleFLSSelection(lead.id, flsId)
                      }
                      placeholder="Select User"
                    />
                  </td>

                  {/* Action Column */}
                  <td className="w-1/3 px-6 py-2 text-center">
                    <button
                      onClick={() =>
                        handleAssign(lead.id, selectedFLSForLeads[lead.id])
                      }
                      disabled={!selectedFLSForLeads[lead.id]}
                      className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded text-sm font-medium transition-colors ${
                        selectedFLSForLeads[lead.id]
                          ? "bg-red-600 text-white hover:bg-red-700 cursor-pointer"
                          : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    >
                      <UserCheck size={16} />
                      {activeTab === "manual"
                        ? isLeadAssigned(lead)
                          ? "Reassign"
                          : "Assign"
                        : "Reassign"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredLeads.length === 0 && (
            <div className="text-center py-8 text-gray-500 border-t border-gray-200">
              No leads found.
            </div>
          )}
        </div>
      </>
    );
  };

  const renderAssignedTabContent = () => {
    return (
      <>
        <div className="relative flex-1 max-w-md my-[10px] mb-6">
          <input
            type="text"
            placeholder="Search leads by name.."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full pl-4 pr-10 py-2 border border-[#888888] rounded-[4px] focus:outline-none focus:border-[#dc3545] text-[14px]"
          />
          <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-4 h-4" />
        </div>

        <div className="">
          <div className="grid grid-cols-5">
            <div className="px-5 py-4 text-left text-sm font-semibold text-gray-700 ">
              Leads
            </div>
            <div className="px-5 py-4 text-left text-sm font-semibold text-gray-700 ">
              Last Status
            </div>
            <div className="px-5 py-4 text-left text-sm font-semibold text-gray-700 ">
              Current Assigned User
            </div>
            <div className="px-5 py-4 text-center text-sm font-semibold text-gray-700 ">
              Select USER
            </div>
            <div className="px-5 py-4 text-center text-sm font-semibold text-gray-700 ">
              Action
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="border border-[#888888] rounded-[4px] ">
          <table className="table-fixed w-full border-collapse">
            <tbody className="bg-white h-1/4">
              {filteredLeads.map((lead, index) => (
                <tr
                  key={lead.id}
                  className={`${
                    index !== filteredLeads.length - 1
                      ? "border-b border-gray-200"
                      : ""
                  } hover:bg-gray-50 transition-colors 
                  }`}
                >
                  <td className="w-1/5 px-4 py-2 text-left">
                    <div className="inline-flex items-center gap-2">
                      <span className="font-medium text-gray-900 text-sm">
                        #{lead.id}
                      </span>
                      <span className="text-gray-700 text-sm">{lead.name}</span>
                    </div>
                  </td>

                  <td className="w-1/5 px-4 py-2  text-left">
                    <div className="inline-flex items-center gap-2">
                      <span className="font-medium text-gray-900 text-sm">
                        {lead.status || "N/A"}
                      </span>
                      {/* <span className="text-gray-700 text-sm">{lead.name}</span> */}
                    </div>
                  </td>
                  <td className="w-1/5 px-4 py-2  text-left">
                    <div className="inline-flex items-center gap-2">
                      <span className="font-medium text-gray-900 text-sm">
                        {lead.assignedUser?.name || "Not Assigned"}
                      </span>
                      {/* <span className="text-gray-700 text-sm">{lead.name}</span> */}
                    </div>
                  </td>

                  {/* FLS Selection Column */}
                  <td className="px-6 py-2   w-1/5">
                    <SearchableDropdown
                      options={getFLSOptionsForLead(lead)}
                      label="displayName"
                      id="id"
                      selectedVal={selectedFLSForLeads[lead.id] || ""}
                      handleChange={(flsId) =>
                        handleFLSSelection(lead.id, flsId)
                      }
                      placeholder="Select User"
                    />
                  </td>

                  {/* Action Column */}
                  <td className="w-1/5 px-6 py-2 text-center">
                    <button
                      onClick={() =>
                        handleAssign(lead.id, selectedFLSForLeads[lead.id])
                      }
                      disabled={!selectedFLSForLeads[lead.id]}
                      className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded text-sm font-medium transition-colors ${
                        selectedFLSForLeads[lead.id]
                          ? "bg-red-600 text-white hover:bg-red-700 cursor-pointer"
                          : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    >
                      <UserCheck size={16} />
                      {activeTab === "manual"
                        ? isLeadAssigned(lead)
                          ? "Reassign"
                          : "Assign"
                        : "Reassign"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {filteredLeads.length === 0 && (
            <div className="text-center py-8 text-gray-500 border-t border-gray-200">
              No leads found matching your search criteria.
            </div>
          )}
        </div>
      </>
    );
  };

  if (
    assignedLeadsLoading ||
    assignedFlsLoading ||
    userProfileLoading ||
    accountLoading
  ) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading...
      </div>
    );
  }

  return (
    <div className="bg-[#f4f4f4] min-h-screen p-6 mt-[65px] ml-[90px] global">
      <div className="bg-white rounded-md shadow-sm mb-3 p-3 min-h-screen">
        {/* Tab Switch Header */}
        <div className="flex justify-center mb-6">
          <div className="bg-gray-200 rounded-full p-1 inline-flex">
            <button
              onClick={() => {
                setActiveTab("manual");
                assignedLeadsRefetch();
              }}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                activeTab === "manual"
                  ? "bg-white text-red-500 shadow-sm "
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              Manual Assign
            </button>
            <button
              onClick={() => {
                setActiveTab("reassign");
                assignedLeadsRefetch();
              }}
              className={`px-6 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                activeTab === "reassign"
                  ? "bg-white text-red-500 shadow-sm  "
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              Reassign Lead
            </button>
          </div>
        </div>

        {/* Tab Content */}
        {/* {renderTabContent()} */}
        {activeTab === "manual"
          ? renderManualTabContent()
          : renderAssignedTabContent()}
      </div>

      <PaginationBar
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={limit}
        hasNextPage={hasNextPage}
        hasPreviousPage={hasPreviousPage}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
        handlePageChange={handlePageChange}
      />
    </div>
  );
};

export default LeadAssign;
